
//// wbskAjaxSearch
(function($, window, undefined) {

  var defaults = {
    view:'ajaxSearch'
  }
  
  function wbskAjaxSearch(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.settings.searchInput = this.settings.searchInput ? this.settings.searchInput : this.element.find('[name="q"]')
    this.bind()
  }

  wbskAjaxSearch.prototype = {
    
    bind:function(){
      var _this = this
      
      _this.settings.searchInput.on('keyup',function(e){
        var terms = $(this).val()
        if(terms.length > 2){
          _this.update(terms)
        }
      })
    },
    
    update:function(terms){
      var _this = this,
          url = `/search?type=product&view=${_this.settings.view}&q=${terms}*`
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
      }
      _this.get(url).then(function(html){
        _this.settings.resultsContainer.html(html)
          if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.removeClass(_this.settings.loadingClass)
        }
      })
    },
    
    get:function(url){
      return new Promise(function(resolve,reject){
        fetch(url).then(function(result){
          return result.text();
        }).then(function(html){
          resolve(html);
        })
      })
    }
   
  }

  $.fn.wbskAjaxSearch = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskAjaxSearch', new wbskAjaxSearch(this, settings))
    })
  }

}(jQuery, window));

